export const environment = {
  production: false,
  env: 'local',
  version: '1.0.0',
  logging: 'warn', // debug, info, warn, error
  API_URL: 'https://dev.enterprise.api.treesoflives.com',
  APP_URL: 'https://dev.enterprise.treesoflives.com',
  AWS_REGION: 'us-east-1',
  API_SERVICE: 'execute-api',
  IDENTITY_POOL_ID: 'us-east-1:757fb249-a57e-4b7c-8c5f-cc40c57eaef0',
  USER_POOL_ID: 'us-east-1_RtEUOLcjS',
  USER_POOL_WEB_CLIENT_ID: '24ojmkg55eg5to5sv7ugsshola',
  API_NAME: 'api',
  origin: 'https://dev.enterprise.treesoflives.com',
  sentry_env: 'local',
  SENTRY_DSN: 'https://c575ba241df02a0b027d7e78af35429e@o490175.ingest.sentry.io/4505646070824960',
  HERE_API_KEY: '4lbd_6gn0Qay2QDTOHBgyiIzPCHk5OI_qQWvpIEu0uw',
  FDM_API_NAME: 'fdm-api',
  FDM_API_URL: 'https://dev.fdm.api.treesoflives.com',
  FDM_API_KEY: 'S0MlPyBLEN5ogDITnc3Oq3az3cqTGCtoeoPppdTb',
  RESTRICTED_BUCKET: 'treesoflives-enterprise-investor-api-dev-restricted-docs',
};
